import type { FC } from "react";
import { FiThumbsDown, FiThumbsUp } from "react-icons/fi";
import { colours } from "../../styles/colours.constants";
import Icon from "../icon/icon";
import * as CSS from "./emoji-button.styles";

type ReactionType = "thumbs_up" | "thumbs_down";

type EmojiButtonProps = {
	disabled: boolean;
	onClick: () => void;
	reactionType: ReactionType;
	value: number;
};

const EmojiButton: FC<EmojiButtonProps> = ({
	reactionType,
	value,
	disabled,
	onClick,
}) => {
	return (
		<CSS.EmojiButton disabled={disabled} onClick={onClick}>
			<Icon
				size={15}
				color={colours.black}
				icon={reactionType === "thumbs_up" ? FiThumbsUp : FiThumbsDown}
			/>
			<CSS.Value>{value}</CSS.Value>
		</CSS.EmojiButton>
	);
};

export default EmojiButton;
